import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
	Box,
	Container,
	Typography,
	CircularProgress,
	Card,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useSubscription } from "../../contexts/SubscriptionContext";

const PageContainer = styled(Box)(() => ({
	minHeight: "100vh",
	background: "linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%)",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
}));

const SuccessCard = styled(Card)(() => ({
	maxWidth: 500,
	width: "100%",
	padding: "48px",
	borderRadius: "16px",
	boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
	textAlign: "center",
}));

const PaymentSuccess: React.FC = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const sessionId = searchParams.get("session_id");
	const { refreshSubscription } = useSubscription();

	useEffect(() => {
		// Refresh subscription immediately to get updated plan
		refreshSubscription().then(() => {

		});

		// Redirect to dashboard after 3 seconds
		const timer = setTimeout(() => {
			navigate("/dashboard");
		}, 3000);

		return () => clearTimeout(timer);
	}, [navigate, refreshSubscription]);

	return (
		<PageContainer>
			<Container>
				<motion.div
					initial={{ opacity: 0, scale: 0.9 }}
					animate={{ opacity: 1, scale: 1 }}
					transition={{ duration: 0.5 }}
				>
					<SuccessCard>
						<CheckCircleIcon
							sx={{
								fontSize: 80,
								color: "#4caf50",
								marginBottom: 2,
							}}
						/>

						<Typography
							variant="h4"
							sx={{
								fontWeight: 700,
								color: "#2c3e50",
								marginBottom: "16px",
							}}
						>
							Payment Successful!
						</Typography>

						<Typography
							variant="body1"
							sx={{
								color: "#6c757d",
								marginBottom: "32px",
								fontSize: "18px",
							}}
						>
							Thank you for subscribing to Arteh. Your
							subscription is now active.
						</Typography>

						{sessionId && (
							<Typography
								variant="body2"
								sx={{
									color: "#9e9e9e",
									marginBottom: "24px",
									fontSize: "14px",
								}}
							>
								Session ID: {sessionId}
							</Typography>
						)}

						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
						>
							<CircularProgress
								size={20}
								sx={{ color: "#5DBEC3" }}
							/>
							<Typography
								variant="body2"
								sx={{ color: "#6c757d" }}
							>
								Redirecting to dashboard in a few seconds...
							</Typography>
						</Box>
					</SuccessCard>
				</motion.div>
			</Container>
		</PageContainer>
	);
};

export default PaymentSuccess;
